import { Box, Container } from "theme-ui";

export const MasterDisclaimer = (props: {
  color?: string;
  hidePayday?: boolean;
}) => {
  return (
    <div
      sx={{
        small: {
          variant: "text.disclaimer",
          display: "block",
          mb: "20px",
          color: props.color || "black",
        },
      }}
    >
      <Box>
        <small>
          Loan availability and loan amounts vary by location. Cash-based
          services such as money orders, money transfers, the ability to pick up
          cash or make a payment with cash at the branch vary by location. Visit
          the store finder page at{" "}
          <a
            sx={{
              textDecoration: "underline",
            }}
            href="https://www.cashmoney.ca/find-a-store/"
          >
            www.cashmoney.ca/find-a-store
          </a>{" "}
          for each branch’s list of services.
        </small>
      </Box>
      <Box>
        <small>
          Lending decisions and funding times are subject to system limitations.
        </small>
      </Box>
      <Box>
        <small>
          <sup>§</sup>Applying to view the value you are pre-approved for will
          only result in a soft credit check which will not affect your credit
          score. However, if you decide to accept a Line of Credit or an Auto
          Equity Loan, then a hard inquiry will occur which may have an impact.{" "}
        </small>
      </Box>
      <Box>
        <small>
          15-minute funding available only when using <i>Interac</i> e-Transfer
          <sup>®</sup> (up to $10,000). Payments and funding via <i>Interac</i>{" "}
          e-Transfer are subject to bank processing times, bank participation,
          and system limitations, including daily send limits. <i>Interac</i>{" "}
          e-Transfer is a registered trade-mark, and the <i>Interac</i> logo is
          a trade-mark of Interac Corp. Used under licence.
        </small>
      </Box>
      <Box>
        <small>
          Lines of Credit: Loan maximum of $10,000, based on a completed
          application, net pay, and other qualification requirements, and
          customer verification including a credit check. Payments are due on
          scheduled income deposits. Cash Money offers personal loans and is not
          a credit repair service. APR/Annual Interest Rate: 34.99%. BC Licence
          #83707.
        </small>
      </Box>
      <Box>
        <small>
          Auto Equity Loan: Loan maximum of $10,000. APR 34.99% based on a
          completed application, net pay, and other qualification requirements,
          and customer verification including a credit check. Security search
          and lien fees apply. Amount varies by province. Visit
          cashmoney.ca/lien-fees for details. Payments are due on scheduled
          income deposits. Cash Money offers personal loans and is not a credit
          repair service. BC Licence #83707.
        </small>
      </Box>
      <Box>
        <small>
          †Cash Money reports Auto Equity Loan payment history to Equifax
          <sup>®</sup> Canada credit bureau so it can help build your credit if
          used responsibly. Building credit is accomplished by paying all your
          bills on time every month. Late payments, missed payments, or other
          defaults on your account may be reflected in your credit report and
          may impact your ability to build credit.
        </small>
      </Box>
      <Box>
        <small>
          ‡Loan Protection: Must be 18 years of age or older and under 70 years
          of age to be eligible. The optional Loan Protection Plan is a Credit
          Group Insurance Plan Underwritten by Canadian Premier Life Insurance
          Company and Canadian Premier General Insurance Company.
        </small>
      </Box>
      {!props.hidePayday && (
        <Box>
          <small>
            <b>Payday Loans are high-cost loans.</b> Loan amounts are subject to
            net pay and other qualification requirements.
          </small>
        </Box>
      )}
      <Box>
        <small>
          <strong>British Columbia Residents:</strong> The maximum charges
          permitted in British Columbia for a Payday Loan is 14% of the
          principal. We charge $14 per $100 borrowed. On a $300 loan for 14
          days, the total cost of borrowing is $42, with a total payback amount
          of $342 and an APR of 365.00%. BC License #50066.
        </small>
      </Box>
      <Box>
        <small>
          <strong>Manitoba Residents:</strong> The maximum allowable charge for
          a payday loan is 14% of the principal amount of the loan. We charge$14
          per each $100 loaned. Sample loan on a $300 loan for 12 days, the cost
          of borrowing is $42, the total that must be repaid is $342 and an APR
          of 425.83%.
          <i>
            To learn more about your rights as a payday loan borrower, contact
            the the Consumer Protection Office at{" "}
            <a sx={{ textDecoration: "underline" }} href="tel:12049453800">
              1-204-945-3800
            </a>
            ,{" "}
            <a sx={{ textDecoration: "underline" }} href="tel:18007820067">
              1-800-782-0067
            </a>{" "}
            or at{" "}
            <a
              sx={{ textDecoration: "underline" }}
              href="https://www.gov.mb.ca/cp/cpo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.gov.mb.ca/cp/cpo/
            </a>
            .
          </i>
        </small>
      </Box>
      <Box>
        <small>
          <strong>Newfoundland Residents:</strong> The maximum allowable cost of
          borrowing under payday loan agreements in Newfoundland and Labrador is
          $14 per $100 borrowed. We charge $14 per each $100 borrowed.On a $300
          loan for 14 days, the total cost of borrowing is $42, with a total
          payback amount of $342 and an APR of 365.00%. License #21-23-CA291-1.
        </small>
      </Box>
      <Box>
        <small>
          <strong>Nova Scotia Residents:</strong> The cost of borrowing is
          $14.00 per $100 on a $300 loan for 14 days (365.00% APR).
        </small>
      </Box>
      <Box>
        <small>
          <strong>Ontario Residents:</strong>The maximum allowable cost of
          borrowing per $100 borrowed in Ontario is $14. We charge $14 per $100
          borrowed. On a $500 loan for 14 days, the cost of borrowing is $70,
          with a total repayment amount of $570 and an APR of 365.00%.
        </small>
      </Box>
      <Box>
        <small>
          <strong>Saskatchewan Residents:</strong> The maximum allowable cost of
          borrowing under payday loan agreements in Saskatchewan is $14 per $100
          borrowed. We charge $14 per each $100 borrowed. On a $300 loan for 14
          days, the total cost of borrowing is $42, with a total payback amount
          of $342 and an APR of 365.00%.
        </small>
      </Box>
      <Box>
        <small>
          Western Union<sup>&#xae;</sup> and the Western Union<sup>&#xae;</sup>{" "}
          logo are registered trademarks of Western Union<sup>&reg;</sup>{" "}
          Holdings, Inc.
        </small>
      </Box>
      <Box>
        <small>
          Google Play is a trademark of Google Inc. Apple and the Apple logo are
          trademarks of Apple Inc., registered in the U.S. and other countries.
          App Store is a service mark of Apple Inc. Data rates may apply.
        </small>
      </Box>
    </div>
  );
};
